module.exports = __webpack_public_path__ + "static/media/outside.42eac2b6.png";